
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../../components/base/Button';

export const ServicesSection: React.FC = () => {
  const services = [
    {
      title: "Leisure Travel",
      image: "/images/services-vacation.jpg",
      description: "Relax and unwind with our carefully curated leisure travel packages designed for ultimate comfort and enjoyment."
    },
    {
      title: "Solo Travel",
      image: "/images/services-businessman.jpg",
      description: "Embark on a journey of self-discovery with our specialized solo travel experiences and safety-focused itineraries."
    },
    {
      title: "Grandeur Travel",
      image: "/images/services-event-hall.jpg",
      description: "Experience luxury at its finest with our premium travel packages featuring world-class accommodations and exclusive experiences."
    },
    {
      title: "Cruises",
      image: "/images/services-cruise.jpg",
      description: "Sail away to exotic destinations with our comprehensive cruise packages offering unparalleled ocean adventures."
    }
  ];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8">
            Our Services
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-2">
              <div className="relative">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-64 object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
              </div>

              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-4">
                  {service.title}
                </h3>

                <p className="text-gray-700 mb-6 leading-relaxed">
                  {service.description}
                </p>

                <Link to="/contact" className="block">
                  <Button variant="primary" size="sm" className="w-full">
                    <i className="ri-mail-line w-4 h-4 flex items-center justify-center"></i>
                    Quote Request
                  </Button>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
